/**
 * =============================================================================
 * SCRIPT-NAME:   AdminDashboard.js
 * PROJEKT:       Freiseinapp - Admin-Zentrale
 * BESCHREIBUNG:  Haupt-Navigations-Hub für die Verwaltung von Kontakten, 
 * Analysen, E-Mail-Versand und Google Ads (Assets & Keywords).
 *
 * VERSION:       v1.i25
 * DATUM:         2026-01-30
 *
 * ÄNDERUNGEN ZUR VORVERSION (v1.i24):
 * - Integration der Route /ads-keywords für das Keyword-Management.
 * - Konsistente Nutzung von <Link> zur Vermeidung von Auth-Verlusten.
 * =============================================================================
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Ermöglicht Navigation ohne Login-Verlust
import BackButton from "./BackButton";
import "./AdminDashboard.css";

export default function AdminDashboard() {
    const logo = "/logo192.png";
    const [currentDateTime, setCurrentDateTime] = useState(new Date());

    // Live-Uhrzeit für den Header-Bereich (User-Präferenz)
    useEffect(() => {
        const timerId = setInterval(() => {
            setCurrentDateTime(new Date());
        }, 1000);
        return () => {
            clearInterval(timerId);
        };
    }, []);

    const formattedDateTime = currentDateTime.toLocaleString('de-DE', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });

    return (
        <div className="dashboard-page-wrapper">
            <div className="dashboard-content-box">

                <header className="dashboard-header">
                    <div className="dashboard-header-left">
                        <img src={logo} alt="FreiSeinApp Logo" className="dashboard-logo" />
                        <div className="dashboard-header-info">
                            <p className="dashboard-welcome">Willkommen im Adminbereich!</p>
                            <p className="dashboard-current-datetime">
                                Aktuell: {formattedDateTime}
                            </p>
                        </div>
                    </div>
                    <h2 className="dashboard-title">👨‍💼 Admin Dashboard</h2>
                </header>
                
                <nav className="dashboard-nav">
                    <ul>
                        {/* --- OPERATIVE DATEN & KONTROLL-TOOLS --- */}
                        <li><Link to="/contacts">📇 Kontakte & GADS Upload</Link></li>
                        <li><Link to="/admin-freischaltung">🔓 Freischaltungen</Link></li>
                        <li><Link to="/analytics">📊 Landingpage Analyse</Link></li>
                        
                        {/* --- TRACKING & JOURNEY --- */}
                        <li><Link to="/user-journey">👣 User-Journey Explorer</Link></li>
                        
                        {/* --- ADS STRATEGIE (REACT-INTERN) --- */}
                        <li><Link to="/ads-manager" className="nav-highlight">📢 Ads Asset Manager</Link></li>
                        <li><Link to="/ads-keywords" className="nav-highlight">🔑 Ads Keyword Manager</Link></li>
                        
                        {/* --- ANALYSE & KOMMUNIKATION --- */}
                        <li><Link to="/kdi-tracker">📈 KDI-Wettbewerbsanalyse</Link></li>
                        <li><Link to="/send-email">✉️ E-Mail senden</Link></li>
                        <li><Link to="/speed-test">🚀 Geschwindigkeitstest</Link></li>
                        
                        {/* --- OPTISCHE TRENNUNG --- */}
                        <hr className="nav-divider" />
                        
                        {/* --- KI-PROMPTS (EXTERNE PHP-FILES) --- */}
                        <li><a href="/api/selbst_admin_prompts.php">🤖 KI-Prompts (Selbstkonzept)</a></li>
                        <li><a href="/api/webinar_admin_prompts.php">🤖 KI-Prompts (Webinar)</a></li>
                        <li><a href="/api/bza_lp_admin_prompts.php">🤖 KI-Prompts (Landing-Page)</a></li>
                    </ul>
                </nav>
                
                <div className="dashboard-footer">
                    <BackButton />
                </div>
            </div>
        </div>
    );
}